import { Injectable } from "@angular/core";
import { BuilderRequest } from 'src/app/models/requests';
import { Is_NON_Download_Action } from "../constants/actor-action.enum";

@Injectable({ providedIn: 'root' })
export class RequestBuilderHelper {
    getLatestDeadline(index: number, request: BuilderRequest): Date | null{
        if(index !== 0 && request.actors.filter(actor => Is_NON_Download_Action(actor.action)).length > 0) {
            let latestDeadline: Date = new Date(new Date().setDate(new Date().getDate() + 1));
            let previousActor = request.actors.filter((a,i) => Is_NON_Download_Action(a.action) && i < index);
            // unique actors
            previousActor = Object.values(previousActor.reduce((a, b) => ({ ...a, [b.dossierPersonId]: b }), {}));

            previousActor.forEach((a,i) => {
                let actors = request.actors.filter(actor => Is_NON_Download_Action(actor.action) && actor.dossierPersonId === a.dossierPersonId);
                if (i===0) {
                    if (actors[0] && actors[0].deadline) {
                        latestDeadline = new Date(actors[0].deadline);
                    } else
                        return;
                } else {
                    let deadlineDays = 0;
                    if(actors[0].dossierPersonId !== request.actors[0].dossierPersonId) deadlineDays = actors[0].deadlineDays ?? 0;
                    if (actors[0] && actors[0].deadlineDays) latestDeadline = new Date(latestDeadline.setDate(latestDeadline.getDate() + deadlineDays));
                }
            });
            return latestDeadline;
        }
        return null;
    }
}